import { TopPage } from "@/modules/irohana-components/elements/TopPage";
import { InformationDetailPage } from "@/features/information/pages/InformationDetail";
import { AppRoutes } from "@/routes/config";
import React from "react";

const InformationDetail = () => {
  return (
    <>
      <TopPage title="お知らせ" backUrl={AppRoutes.home} />
      <InformationDetailPage />
    </>
  );
};

export default InformationDetail;
